export default [
  // 
  // {
  //   path: '/dashboard',
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import('@/views/homeBoard/dashboard.vue'),
  //   meta: {
  //     title: '经销商工作台',
  //     isTabsPage: true,
  //     keepAlive: true
  //   }
  // },
  // 地图下钻表格页面
  {
    path: '/homeBoard/cityDetails',
    component: () => import('@/views/homeBoard/mapfile/cityDetails.vue'),
  },
  // 协同问题审批
  {
    path: '/homeBoard/feedbackApproval',
    component: () => import('@/views/homeBoard/approvePage/feedbackApproval.vue'),
  },
  // 协同问题答复
  {
    path: '/homeBoard/feedbackAppDetails',
    component: () => import('@/views/homeBoard/approvePage/feedbackAppDetails.vue'),
  },
  // 关差审批详情
  {
    path: '/homeBoard/gapApprovalDetails',
    component: () => import('@/views/homeBoard/approvePage/gapApprovalDetails.vue'),
  },
  // 关差审批发起
  {
    path: '/homeBoard/gapInitiate',
    component: () => import('@/views/homeBoard/approvePage/gapInitiate.vue'),
  },
  // 关差分数维护
  {
    path: '/homeBoard/scoreMaintenance',
    component: () => import('@/views/homeBoard/approvePage/scoreMaintenance.vue'),
  },
  // 区域费用维护
  {
    path: '/region/regionalFees',
    component: () => import('@/views/region/regionalFees.vue'),
  },
]
